import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useApi from '../hooks/useApi';
import NavBar from '../components/navBar';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { request } = useApi();
  const uid = searchParams.get('uid');
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async () => {
    setMessage('');
    if (!uid || !token) {
      setMessage('Invalid reset link.');
      return;
    }
    if (!password) {
      setMessage('Please enter a new password.');
      return;
    }
    if (password.length < 8) {
      setMessage('Password must be at least 8 characters.');
      return;
    }
    if (password !== confirmPassword) {
      setMessage('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      await request({
        method: 'post',
        url: 'api/v1/users/reset-password/',
        data: { uid, token, password },
      });
      setSuccess(true);
      setMessage('Password reset successfully. You can now log in.');
    } catch (err) {
      setMessage(err?.response?.data?.detail || 'Something went wrong. Try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <NavBar isAuthenticated={false} onNavigate={() => navigate('/?view=login')} />
      <div className="pt-20">
        <div className="max-w-md mx-auto mt-20 p-6 bg-white shadow rounded">
          <h2 className="text-2xl font-bold mb-6 text-center">Reset Password</h2>

          {!success ? (
            <>
              <input
                type="password"
                placeholder="New password"
                className="w-full border px-3 py-2 rounded mb-4"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setMessage('');
                }}
              />
              <input
                type="password"
                placeholder="Confirm new password"
                className="w-full border px-3 py-2 rounded mb-6"
                value={confirmPassword}
                onChange={(e) => {
                  setConfirmPassword(e.target.value);
                  setMessage('');
                }}
              />
              <button
                onClick={handleSubmit}
                disabled={loading}
                className="w-full bg-violet-900 text-white py-2 rounded hover:bg-violet-950 disabled:opacity-50"
              >
                {loading ? 'Resetting...' : 'Reset Password'}
              </button>
            </>
          ) : (
            <p className="text-sm text-green-700 text-center mb-4">{message}</p>
          )}

          {message && !success && (
            <p className="mt-4 text-center text-sm text-red-700">{message}</p>
          )}

          {success && (
            <p className="text-sm text-center mt-4">
              <button
                onClick={() => navigate('/?view=login')}
                className="text-violet-900 hover:underline"
              >
                Go to Log In
              </button>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
